import { render, staticRenderFns } from "./SendAskExperience.vue?vue&type=template&id=ef0d9c6c&scoped=true&"
import script from "./SendAskExperience.vue?vue&type=script&lang=ts&"
export * from "./SendAskExperience.vue?vue&type=script&lang=ts&"
import style0 from "./SendAskExperience.vue?vue&type=style&index=0&id=ef0d9c6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef0d9c6c",
  null
  
)

export default component.exports